import { AxiosResponse, AxiosStatusCode } from 'smg/axios';
import * as buttons from 'smg/buttons';
import { LoginAccountLabel } from 'smg/customer-api/login';
import * as models from 'smg/customer-api/models';
import * as session from 'smg/customer-api/session';
import Modal from 'smg/modal';
import { Phone } from 'smg/phone';
import { RedirectAfterLogin } from '../login-code';

main();

function main() {
    if (session.GetLoginToken()) {
        RedirectAfterLogin();
        return;
    }

    // Tab switching (Login / Register)
    const tabs = document.querySelectorAll<HTMLAnchorElement>('.login-tab');
    const panels = document.querySelectorAll<HTMLElement>('.login-tab-panel');
    tabs.forEach(tab => {
        tab.addEventListener('click', e => {
            e.preventDefault();
            const target = tab.dataset.tab;
            if (!target) {
                return;
            }
            document.querySelectorAll<HTMLAnchorElement>('.login-tab').forEach(t => t.classList.toggle('active', t.dataset.tab === target));
            panels.forEach(p => p.classList.toggle('d-none', p.id !== `tab-${target}`));
        });
    });

    // Login method switching (Password / Email Code / Phone Code)
    const methodTabs = document.querySelectorAll<HTMLAnchorElement>('.login-method-tab');
    const methodPanels = document.querySelectorAll<HTMLElement>('.login-method-panel');
    let activeMethod = 'password';

    methodTabs.forEach(tab => {
        tab.addEventListener('click', e => {
            e.preventDefault();
            const method = tab.dataset.method;
            if (!method) {
                return;
            }
            activeMethod = method;
            methodTabs.forEach(t => t.classList.toggle('active', t.dataset.method === method));
            methodPanels.forEach(p => {
                const isActive = p.id === `method-${method}`;
                p.classList.toggle('d-none', !isActive);
                // Disable hidden inputs so they don't block form validation
                p.querySelectorAll<HTMLInputElement>('input').forEach(input => {
                    input.disabled = !isActive;
                });
            });

            // Reset code-sent state when switching methods
            document.querySelectorAll('.code-sent-section').forEach(el => el.classList.add('d-none'));
            document.querySelectorAll<HTMLInputElement>('#email-code, #phone-code').forEach(input => {
                input.disabled = true;
                input.required = false;
            });
            codeSent = false;
            $loginSubmit.textContent = method === 'password' ? 'LOGIN' : 'SEND CODE';
        });
    });

    // Disable inputs in hidden panels on init
    methodPanels.forEach(p => {
        if (p.classList.contains('d-none')) {
            p.querySelectorAll<HTMLInputElement>('input').forEach(input => {
                input.disabled = true;
            });
        }
    });

    const form = document.querySelector('#login-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const $loginSubmit = document.querySelector('#login-submit') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const heading = document.querySelector('#tab-login .login-card-heading') as HTMLElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    const showAlert = (type: 'generic' | 'invalid-email') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');
        heading.after(a);
    };

    const hideAlert = () => {
        document.querySelectorAll('#tab-login .alert').forEach(a => a.remove());
    };

    // Lazy-init phone input only when phone-code method is first used
    let codePhoneInput: Phone | undefined;

    let codeSent = false;

    form.addEventListener('submit', async e => {
        e.preventDefault();
        hideAlert();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start($loginSubmit);

        try {
            if (activeMethod === 'password') {
                await loginWithPassword();
            } else if (activeMethod === 'email-code') {
                await loginWithEmailCode();
            } else if (activeMethod === 'phone-code') {
                await loginWithPhoneCode();
            }
        } catch (err) {
            if (AxiosStatusCode(err) === 400) {
                showAlert('invalid-email');
            } else {
                showAlert('generic');
            }
        } finally {
            fieldset.removeAttribute('disabled');
            buttons.Stop($loginSubmit);
            $loginSubmit.textContent = codeSent ? 'LOGIN' : 'SEND CODE';
        }
    });

    async function loginWithPassword() {
        const email = (document.querySelector('#login-email') as HTMLInputElement).value;
        const password = (document.querySelector('#login-password') as HTMLInputElement).value;

        const resp = await session.CreateSession({ email, password });
        const data = models.SessionCreateResponse.fromJSON(resp.data);
        if (data.token) {
            session.SetLoginToken(data.token);
            RedirectAfterLogin();
        }
    }

    function handleLoginResp(resp: AxiosResponse, identifiers: Record<string, string>) {
        // 202 = multiple accounts for this phone, let user pick
        if (resp.status === 202) {
            const chooser = models.LoginCodeAccountsResponse.fromJSON(resp.data);
            const code = identifiers['code'] || '';
            const phone = identifiers['phone'] || '';

            const body = (document.querySelector('#modal-login-select-email') as HTMLTemplateElement).content.cloneNode(true) as DocumentFragment;
            const $listGroup = body.querySelector('.list-group') as HTMLElement;
            const $listGroupItem = $listGroup.querySelector('.list-group-item') as HTMLAnchorElement;
            $listGroup.removeChild($listGroupItem);

            for (const account of chooser.accounts) {
                const $a = $listGroupItem.cloneNode(true) as HTMLAnchorElement;
                $a.textContent = LoginAccountLabel(account);
                $listGroup.appendChild($a);

                $a.addEventListener('click', e => {
                    e.preventDefault();
                    void session.CreateSession({ phone, userID: account.id, code }).then(r => {
                        const data = models.SessionCreateResponse.fromJSON(r.data);
                        if (data.token) {
                            session.SetLoginToken(data.token);
                            RedirectAfterLogin();
                        }
                    });
                });
            }

            new Modal({ body });
            return;
        }

        const data = models.SessionCreateResponse.fromJSON(resp.data);
        if (data.token) {
            session.SetLoginToken(data.token);
            RedirectAfterLogin();
        }
    }

    async function loginWithEmailCode() {
        const email = (document.querySelector('#code-email') as HTMLInputElement).value;
        const $codeSentSection = document.querySelector('#method-email-code .code-sent-section') as HTMLElement;

        if (!codeSent) {
            await session.CreateLoginCode({ email });
            codeSent = true;
            $codeSentSection.classList.remove('d-none');
            const $codeInput = document.querySelector('#email-code') as HTMLInputElement;
            $codeInput.disabled = false;
            $codeInput.required = true;
            $codeInput.focus();
            return;
        }

        const code = (document.querySelector('#email-code') as HTMLInputElement).value;
        const resp = await session.CreateSession({ email, code });
        handleLoginResp(resp, { email, code });
    }

    async function loginWithPhoneCode() {
        if (!codePhoneInput) {
            codePhoneInput = new Phone(document.querySelector('#code-phone') as HTMLInputElement);
        }
        const phone = await codePhoneInput.format();
        const $codeSentSection = document.querySelector('#method-phone-code .code-sent-section') as HTMLElement;

        if (!codeSent) {
            await session.CreateLoginCode({ phone });
            codeSent = true;
            $codeSentSection.classList.remove('d-none');
            const $codeInput = document.querySelector('#phone-code') as HTMLInputElement;
            $codeInput.disabled = false;
            $codeInput.required = true;
            $codeInput.focus();
            return;
        }

        const code = (document.querySelector('#phone-code') as HTMLInputElement).value;
        const resp = await session.CreateSession({ phone, code });
        handleLoginResp(resp, { phone, code });
    }
}
